var React = require('react');

function Proposal24Inline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"proposal"),React.createElement("g",{"id":"proposal-24","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M18,0 L18,1 L22,1 L22,23 L2,23 L2,1 L10,1 L10,0 L18,0 Z M10,3 L4,3 L4,21 L20,21 L20,3 L18,3 L18,11 L14,9 L10,11 L10,3 Z M14,17 L14,19 L6,19 L6,17 L14,17 Z M16,13 L16,15 L6,15 L6,13 L16,13 Z M16,2 L12,2 L12,7.76393202 L14,6.76393202 L16,7.76393202 L16,2 Z","id":"Combined-Shape","fill":"#000000","fillRule":"nonzero"}))]);
}

Proposal24Inline.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Proposal24Inline;

Proposal24Inline.default = Proposal24Inline;
